import {
  canvasSizePresets, pageFitTypes, pageFitDescriptions, selectedCanvasSize,
  selectedPageFit, canvasSizePatch, canvasDimensionPatch, validCanvasDimension, pageFitPatch, pageFitPreview
} from '@/editor/core/page-settings'
import { limitNodeBounds } from '@/editor/core/component-size'

export default {
  data () {
    return { canvasSizePresets, pageFitTypes, pageDimensionRevision: 0, pageDimensionError: '' }
  },
  computed: {
    pageCanvasSize () { return selectedCanvasSize(this.config) },
    pageFitType () { return selectedPageFit(this.config) },
    pageFitDescription () { return pageFitDescriptions[this.pageFitType] },
    pageFitPreviewStyle () {
      const rect = pageFitPreview(this.config)
      return Object.keys(rect).reduce((style, key) => ({ ...style, [key]: rect[key] + 'px' }), {})
    }
  },
  methods: {
    applyPageSettingsPatch (patch) {
      if (!patch || !this.projectRecord) return false
      this.rememberStructure()
      const reduced = {}
      ;['width', 'height'].forEach(axis => { if (patch[axis] < Number(this.config[axis])) reduced[axis] = patch[axis] })
      Object.keys(patch).forEach(key => this.$set(this.config, key, patch[key]))
      if (Object.keys(reduced).length) limitNodeBounds(this.nav, reduced, this.$set.bind(this))
      // 一次预设及超限外框收回只占一个撤销步骤；不整体缩放布局或编辑视口。
      this.rememberStructure()
      return true
    },
    selectCanvasSize (value) {
      this.pageDimensionError = ''
      return this.applyPageSettingsPatch(canvasSizePatch(this.config, value))
    },
    setPageDimension (axis, value) {
      if (!validCanvasDimension(value)) {
        // Element 数字控件清空时会保留内部空值；重建以恢复原有效尺寸。
        this.pageDimensionRevision++
        this.pageDimensionError = '宽高需为不小于 1 的有效数字，已保留原尺寸。'
        return false
      }
      this.pageDimensionError = ''
      return this.applyPageSettingsPatch(canvasDimensionPatch(this.config, axis, value))
    },
    selectPageFit (value) { return this.applyPageSettingsPatch(pageFitPatch(this.config, value)) }
  }
}
